exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".number-box[data-v-e5386aa6]{background-color:#4f91a3;width:-moz-fit-content;width:fit-content;color:#fff;height:39px}.number-box .number-label[data-v-e5386aa6]{font-size:1.4rem;line-height:1.5rem;font-weight:700;display:inline-block;padding-left:8px;padding-right:6px;vertical-align:top;padding-top:9px}.number-box .icon-container[data-v-e5386aa6]{background-color:rgba(0,0,0,.2);display:inline-block;width:32px;height:38px}.number-box .icon[data-v-e5386aa6]{width:32px;height:29px;background-position:bottom}.number-box .icon.suitcase-icon[data-v-e5386aa6]{padding-top:8px}", ""]);

// exports
